(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8909],{

/***/ 99271:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/search-icon.f50f71c3.svg","height":22,"width":20});

/***/ }),

/***/ 83664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CanonicalURL; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55088);




function CanonicalURL() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: (0,_utility__WEBPACK_IMPORTED_MODULE_3__/* .getCanonicalURL */ .DN)(router)
        })
    });
}


/***/ }),

/***/ 60095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hero_storesearch_banner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(29238);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/promotions/promotion.tsx
var promotion = __webpack_require__(46940);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
// EXTERNAL MODULE: ./src/helper/wordReplace.tsx
var wordReplace = __webpack_require__(27147);
;// CONCATENATED MODULE: ./public/images/icons/phone-icon.svg
/* harmony default export */ var phone_icon = ({"src":"/_next/static/media/phone-icon.d0f3520a.svg","height":32,"width":32});
// EXTERNAL MODULE: ./public/images/icons/search-icon.svg
var search_icon = __webpack_require__(99271);
;// CONCATENATED MODULE: ./public/images/logos/Access-25th-Logo.svg
/* harmony default export */ var Access_25th_Logo = ({"src":"/_next/static/media/Access-25th-Logo.ffc4c086.svg","height":190,"width":600});
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var home_setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/react-places-autocomplete/dist/index.js
var dist = __webpack_require__(48837);
// EXTERNAL MODULE: ./src/context/MapCordinateContext.tsx
var MapCordinateContext = __webpack_require__(20546);
// EXTERNAL MODULE: ./src/utils/default.ts
var utils_default = __webpack_require__(84260);
;// CONCATENATED MODULE: ./src/components/home-content/search-input.tsx













var SearchInput = function() {
    var locale = (0,next_router.useRouter)().locale;
    var ref = (0,react.useState)(""), address = ref[0], setAddress = ref[1];
    var router = (0,next_router.useRouter)();
    var searchOptions = {
        componentRestrictions: {
            country: [
                "ca"
            ]
        }
    };
    var cords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var handleChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setAddress(value);
                return [
                    2
                ];
            });
        });
        return function handleChange(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClick = function(searchItem) {
        var addr = searchItem && (searchItem === null || searchItem === void 0 ? void 0 : searchItem.length) ? searchItem : address;
        if ((addr === null || addr === void 0 ? void 0 : addr.toLowerCase().trim()) === "nova scotia" || (addr === null || addr === void 0 ? void 0 : addr.toLowerCase().trim()) === "nova scotia, canada") {
            router.push("/self-storage/?location=".concat(address, "&lat=").concat(constants/* HALIFAX_LAT_LANG.lat */.JP.lat, "&lng=").concat(constants/* HALIFAX_LAT_LANG.lng */.JP.lng));
        }
        var value = addr && (addr === null || addr === void 0 ? void 0 : addr.length) ? addr.split(",") : address.split(",");
        if (value) {
            /* eslint-disable*/ var address1 = addr;
            var getGeocode = function() {
                var googleMapsGeocoder = new google.maps.Geocoder();
                googleMapsGeocoder.geocode({
                    address: address1,
                    componentRestrictions: {
                        country: "ca"
                    }
                }, function(results) {
                    (0,dist/* getLatLng */.WV)(results[0]).then(function(latLng) {
                        if (address1.includes("#")) {
                            address1 = address1.replace("#", "");
                        }
                        if (latLng === null || latLng.lat === 56.130366 && latLng.lng === -106.346771) {
                            latLng = utils_default/* default.0.center */.Z[0].center;
                        }
                        var cityName = (address1 === null || address1 === void 0 ? void 0 : address1.toLowerCase().includes("halifax")) || (address1 === null || address1 === void 0 ? void 0 : address1.toLowerCase().trim()) === "nova scotia" || (address1 === null || address1 === void 0 ? void 0 : address1.toLowerCase().trim()) === "nova scotia, canada";
                        var coords = cityName ? constants/* HALIFAX_LAT_LANG */.JP : latLng;
                        cords.setLatLangs(coords);
                        cords === null || cords === void 0 ? void 0 : cords.setSisterInput(false);
                        router.push("/self-storage/?location=".concat(address1, "&lat=").concat(coords.lat, "&lng=").concat(coords.lng));
                    });
                });
            };
            if (typeof google !== "undefined" && google.maps) {
                getGeocode();
            } else {
                var interval = setInterval(function() {
                    if (typeof google !== "undefined" && google.maps) {
                        clearInterval(interval);
                        getGeocode();
                    }
                }, 250);
            }
        }
    };
    var handleSelect = function(value) {
        setAddress(value);
        cords.setAddresses(value);
        handleClick(value);
    };
    (0,react.useEffect)(function() {
        if (address) {
            setAddress(address);
        }
    }, [
        address
    ]);
    // Log error status and clear dropdown when Google Maps API returns an error.
    var onError = function(status, clearSuggestions) {
        console.log("Google Maps API returned error with status: ", status);
        clearSuggestions();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
            value: address,
            onChange: handleChange,
            onSelect: handleSelect,
            searchOptions: searchOptions,
            googleCallbackName: "initTwo",
            onError: onError,
            children: function(param) {
                var getInputProps = param.getInputProps, suggestions = param.suggestions, getSuggestionItemProps = param.getSuggestionItemProps, loading = param.loading;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                            className: "form-control d-none d-lg-block d-md-block"
                        }, getInputProps({
                            disabled: false,
                            placeholder: "".concat(locale === "en" ? constants/* SEARCH_PLACEHOLDER_EN */.l3 : constants/* SEARCH_PLACEHOLDER_FR */.nr)
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                            className: "form-control d-block d-lg-none d-md-none"
                        }, getInputProps({
                            disabled: false,
                            placeholder: "".concat(locale === "en" ? constants/* SEARCH_PLACEHOLDER_EN_MOB */.tU : constants/* SEARCH_PLACEHOLDER_FR_MOB */.qH)
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn search-btn find-units",
                            type: "button",
                            onClick: handleClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "find-unit"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn search-btn search-units",
                            type: "button",
                            onClick: handleClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "buttons.search"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "suggestions-dropdown",
                            children: [
                                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "...loading"
                                }) : null,
                                suggestions.map(function(suggestion, index) {
                                    var style = {
                                        backgroundColor: suggestion.active ? "#e9ecef" : "#fff"
                                    };
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,react.createElement)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            className: "options"
                                        }, getSuggestionItemProps(suggestion, {
                                            style: style
                                        })), {
                                            key: index
                                        }), suggestion.description)
                                    });
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var search_input = (SearchInput);

// EXTERNAL MODULE: ./src/components/utility.ts
var utility = __webpack_require__(55088);
;// CONCATENATED MODULE: ./src/components/hero-banner/hero-storesearch-banner.tsx















// import imgLink from '@/public/images/logos/access_storage_logo.svg';





var BreadCrumbs = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8106).then(__webpack_require__.bind(__webpack_require__, 5553));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5553)
            ];
        }
    }
});
// This component is the genetic hero image with search input + CTA banner
// TODO: We might want to show the default image if there is no background image provided
var HeroStoreSearchBanner = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var router = (0,next_router.useRouter)();
    var isBread = props.isBread, cmsData = props.cmsData;
    var section = cmsData && (cmsData === null || cmsData === void 0 ? void 0 : cmsData.attributes) && (cmsData === null || cmsData === void 0 ? void 0 : cmsData.attributes.Section);
    var title = section && section[0] && section[0].Title;
    var subTitle = section && section[0] && section[0].Sub_Title;
    var cta = section && section[1];
    var imgUrl = section && ((ref = section[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.Background_Image) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.url);
    var ref23 = (0,react.useState)(false), isScrolled = ref23[0], setIsScrolled = ref23[1];
    var ref24 = (0,react.useState)("sv-page-content scrollText"), scrollText = ref24[0], setScrollText = ref24[1];
    var pathWithoutQuery = isBread && router.asPath.split("?")[0];
    var brandUrl = (props === null || props === void 0 ? void 0 : props.hostUrl) ? "https://".concat(props.hostUrl) : constants/* SITE_URL */._O;
    var brandTitle = constants/* SITE_TITLE */.jG;
    var locale = (0,next_router.useRouter)().locale;
    var ref25 = (0,react.useState)([]), brands = ref25[0], setBrands = ref25[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,home_setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        setBrands(contextData === null || contextData === void 0 ? void 0 : contextData.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        locale
    ]);
    var handleScrolled = (0,react.useCallback)(function(e) {
        e.preventDefault();
        var scrollValue = Math.floor(window.scrollY);
        if (scrollValue > 295) {
            setIsScrolled(true);
            setScrollText("sv-page-content scrollText scroll");
        } else {
            setIsScrolled(false);
            setScrollText("sv-page-content scrollText");
        }
    }, [
        isScrolled
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function(e) {
            return handleScrolled(e);
        });
        return function() {
            window.removeEventListener("scroll", function() {
                return handleScrolled;
            });
        };
    }, [
        isScrolled
    ]);
    var headerFooter = (0,react.useContext)(HeaderFooterContext/* default */.ZP).headerFooter;
    var contactNumber = (ref4 = headerFooter[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.RC_Contact_Number;
    var breadCrumbUrlList = (0,utility/* generateDynamicBCLD */.W_)(router);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: scrollText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-xl custom-container px-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "hero-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "hero-banner",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        sizes: "(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1280px",
                                        src: imgUrl || "",
                                        alt: ((ref6 = section[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.Background_Image) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.attributes) === null || ref9 === void 0 ? void 0 : ref9.alternativeText) || ((ref10 = section[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.Background_Image) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.attributes) === null || ref13 === void 0 ? void 0 : ref13.name),
                                        height: "540",
                                        width: "1000",
                                        className: "banner-img",
                                        priority: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "banner-content",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "row",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-xl-12 col-lg-12 col-md-12 col-sm-12 m-auto",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "center-box",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    children: title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: browser_default().sanitize((0,wordReplace/* replaceWithRequiredSiteInfo */.u2)(brandTitle, brandUrl, subTitle))
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "search-section",
                                                            id: "search-navbar",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "container",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "d-flex justify-content-between align-items-center m-auto",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "item-logo hidden-xxs",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "/",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    className: "navbar-brand",
                                                                                    children: (brands === null || brands === void 0 ? void 0 : brands.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                        src: (ref14 = brands[0]) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.attributes) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.Logo) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.attributes) === null || ref18 === void 0 ? void 0 : ref18.url,
                                                                                        alt: "storage-logo",
                                                                                        width: "130",
                                                                                        height: "60",
                                                                                        priority: true
                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                        src: Access_25th_Logo,
                                                                                        alt: "storage-logo",
                                                                                        width: "130",
                                                                                        height: "60",
                                                                                        priority: true
                                                                                    })
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "search-bar locationSearch",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "search-icon",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            src: search_icon/* default */.Z,
                                                                                            alt: "search-icon",
                                                                                            priority: true
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(search_input, {})
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "item-phone",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    className: "phone-link headerPhone",
                                                                                    href: "tel:".concat(contactNumber),
                                                                                    children: contactNumber
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    className: "headerPhone phoneIcon",
                                                                                    href: "tel:".concat(contactNumber),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                        src: phone_icon,
                                                                                        alt: "phone-icon",
                                                                                        priority: true
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(promotion/* default */.Z, {
                                cta_section: ((ref19 = brands[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.attributes) === null || ref20 === void 0 ? void 0 : ref20.CTA_Section.push_brand_cta) === true ? (ref21 = brands[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.attributes) === null || ref22 === void 0 ? void 0 : ref22.CTA_Section : cta
                            })
                        ]
                    })
                })
            }),
            isBread && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs, {
                        path: pathWithoutQuery
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                        itemListElements: breadCrumbUrlList
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var hero_storesearch_banner = (HeroStoreSearchBanner);


/***/ }),

/***/ 46940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1781);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Promotion = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var cta = props === null || props === void 0 ? void 0 : props.cta_section;
    var bgImageDesktop = cta === null || cta === void 0 ? void 0 : (ref = cta.bg_image_desktop) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.url;
    var bgImageMobile = cta === null || cta === void 0 ? void 0 : (ref3 = cta.bg_image_mobile) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.url;
    var bgColor = cta === null || cta === void 0 ? void 0 : cta.bg_color;
    var ctaTitle = cta === null || cta === void 0 ? void 0 : cta.Title;
    var ctaImage = cta === null || cta === void 0 ? void 0 : (ref6 = cta.Background_Image) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.attributes) === null || ref8 === void 0 ? void 0 : ref8.url;
    var ctaLink = cta === null || cta === void 0 ? void 0 : cta.Link;
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(bgImageDesktop), bgImage = ref12[0], setBgImage = ref12[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var updateBackgroundImage = function() {
            if ((window === null || window === void 0 ? void 0 : window.innerWidth) <= 576) {
                setBgImage(bgImageMobile);
            } else {
                setBgImage(bgImageDesktop);
            }
        };
        updateBackgroundImage();
        window.addEventListener("resize", updateBackgroundImage);
        return function() {
            window.removeEventListener("resize", updateBackgroundImage);
        };
    }, [
        bgImageDesktop,
        bgImageMobile
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "promotion-banner-general",
        style: {
            background: "".concat(bgImageDesktop ? "" : bgColor || "")
        },
        children: bgImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: bgImage,
            alt: cta === null || cta === void 0 ? void 0 : (ref9 = cta.bg_image_desktop) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : ref11.alt,
            className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().promotionBannerImage)
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "d-flex",
            children: [
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    children: [
                        ctaTitle,
                        ctaLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: "text-white cursor-pointer ms-2",
                            href: ctaLink === null || ctaLink === void 0 ? void 0 : ctaLink.Slug_or_URL,
                            children: [
                                "– ",
                                ctaLink === null || ctaLink === void 0 ? void 0 : ctaLink.Text
                            ]
                        })
                    ]
                }),
                ctaImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: ctaImage,
                    alt: ctaTitle
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Promotion);


/***/ }),

/***/ 66156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ getConvenientLocations; },
/* harmony export */   "YW": function() { return /* binding */ getHeaderAndFooterDetailsWithDefaultLocale; },
/* harmony export */   "Zy": function() { return /* binding */ getRightUnitInfo; },
/* harmony export */   "co": function() { return /* binding */ getVehicleLandingData; },
/* harmony export */   "fC": function() { return /* binding */ getCityLandingInfo; },
/* harmony export */   "fU": function() { return /* binding */ getInnerPagesWithDefaultLocale; },
/* harmony export */   "k5": function() { return /* binding */ getBrandReviews; },
/* harmony export */   "ns": function() { return /* binding */ getGoogleReviews; },
/* harmony export */   "zc": function() { return /* binding */ getOurBrands; }
/* harmony export */ });
/* unused harmony exports getGoogleReview, getHomeBodyDetailsWithDefaultLocale, getStudentSpecialContent, getValidityCity */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getHeaderAndFooterDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getBrandLocaleUrl */ .oo(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHeaderAndFooterDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getHomeBodyDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getHomeLocaleUrl */ .dK(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHomeBodyDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getBrandReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GOOGLE_CLIENT_REVIEWS */ .Zk), "get")
            ];
        });
    });
    return function getBrandReviews() {
        return _ref.apply(this, arguments);
    };
}();
var getOurBrands = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GET_OUR_BRANDS */ .e), "get")
            ];
        });
    });
    return function getOurBrands() {
        return _ref.apply(this, arguments);
    };
}();
// for future lcode include
var getGoogleReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReviews */ .Vf(lcode)), "get")
            ];
        });
    });
    return function getGoogleReviews(lcode) {
        return _ref.apply(this, arguments);
    };
}();
var getGoogleReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReview */ .tw(lcode, locale)), "get")
            ];
        });
    });
    return function getGoogleReview(lcode, locale) {
        return _ref.apply(this, arguments);
    };
}();
// lat, lng, brand, limit,
var getConvenientLocations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lang, cords) {
        var ncards;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            ncards = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .CONVENIENT_LOCATIONS */ .vi, "?lat=").concat(cords === null || cords === void 0 ? void 0 : cords.latitude, "&lng=").concat(cords === null || cords === void 0 ? void 0 : cords.longitude, "&brand=as&limit=").concat(ncards, "&lang=").concat(lang), "get")
            ];
        });
    });
    return function getConvenientLocations(lang, cords) {
        return _ref.apply(this, arguments);
    };
}();
// brand section
var getInnerPagesWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(innerPageName) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getInnerPagesUrl */ .zP(innerPageName, brand, locale)), "get")
            ];
        });
    });
    return function getInnerPagesWithDefaultLocale(innerPageName) {
        return _ref.apply(this, arguments);
    };
}();
// student special content
var getStudentSpecialContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(defaultLink, locale, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getStudentSpecialUrl */ .Sh(defaultLink, locale, brand)), "get")
            ];
        });
    });
    return function getStudentSpecialContent(defaultLink, locale, brand) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getCityLandingInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getCityLandingInfo */ .fC(slug, brand, locale)), "get")
            ];
        });
    });
    return function getCityLandingInfo(slug) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getVehicleLandingData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getVehicleLandingInfo */ .CZ(slug, brand, locale)), "get")
            ];
        });
    });
    return function getVehicleLandingData(slug) {
        return _ref.apply(this, arguments);
    };
}();
// right units
var getRightUnitInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getRightUnitInfo */ .Zy(brand, locale)), "get")
            ];
        });
    });
    return function getRightUnitInfo() {
        return _ref.apply(this, arguments);
    };
}();
// validate city for facility slug
var getValidityCity = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getValidateCity */ .e$(slug, brand)), "get")
            ];
        });
    });
    return function getValidityCity(slug, brand) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 76784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);



var SetBrandsContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var brand, locale, ref, result, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "dp", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
                    return [
                        4,
                        Promise.all([
                            (0,___WEBPACK_IMPORTED_MODULE_0__/* .getHeaderAndFooterDetailsWithDefaultLocale */ .YW)(brand, locale)
                        ])
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (ref = result[0]) === null || ref === void 0 ? void 0 : ref.data
                    ];
                case 2:
                    data = _state.sent() || null;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function SetBrandsContext() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (SetBrandsContext);


/***/ }),

/***/ 84260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var defaultCenters = [
    {
        brand: "as",
        center: {
            lat: 43.7615714,
            lng: -79.2921276
        }
    },
    {
        brand: "dp",
        center: {
            lat: 45.4965782,
            lng: -73.5591249
        }
    },
    {
        brand: "se",
        center: {
            lat: 51.0553635,
            lng: -114.0186927
        }
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (defaultCenters);


/***/ }),

/***/ 1781:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"promotionBannerImage":"style_promotionBannerImage__qOEV6"};

/***/ })

}]);